import { useState } from 'react'
import ConfirmModal from 'ui/components/modals/ConfirmModal/'
import { Tooltip } from 'ui/components/tooltips/Tooltip'
import { USER_ROLE } from 'utils/constants'
import { StatusSwitch } from './styled'

const { MANAGER } = USER_ROLE
const MIN_ACTIVE_MANAGERS = 1

const UserStatusControl = ({
  user,
  activeManagersCount,
  isStatusChanging,
  onStatusChange,
  marginBottom = 0,
}) => {
  const [openModal, setModalOpen] = useState(false)

  const isActive = !user.is_deactivated

  const isManager = user.role?.some((role) => role?.id === MANAGER)

  const isOnlyActiveManager =
    isActive && isManager && activeManagersCount === MIN_ACTIVE_MANAGERS

  const tooltipText = isOnlyActiveManager ? (
    <>
      Нельзя сделать неактивным
      <br />
      единственного менеджера
    </>
  ) : isActive ? (
    'Деактивировать'
  ) : (
    'Активировать'
  )

  const handleStatusChange = () => {
    if (user.is_deactivated) {
      onStatusChange(user.id)
      return
    }

    setModalOpen(true)
  }

  const handleDeactivateConfirm = () => {
    onStatusChange(user.id)
    setModalOpen(false)
  }
  const handleModalClose = () => {
    setModalOpen(false)
  }

  return (
    <>
      <Tooltip placement="top-end" offset={0} title={tooltipText}>
        <div>
          <StatusSwitch
            checked={isActive}
            disabled={isOnlyActiveManager || isStatusChanging}
            onChange={handleStatusChange}
            $marginBottom={marginBottom}
          />
        </div>
      </Tooltip>

      <ConfirmModal
        title={`Вы уверены, что хотите деактивировать пользователя ${user.surname} ${user.name}?`}
        open={openModal}
        handlerClose={handleModalClose}
        confirmHandler={handleDeactivateConfirm}
        confirmText="Деактивировать"
        cancelText="Отменить"
      />
    </>
  )
}

export default UserStatusControl
